import { useEffect, useState } from 'react';
import { vars } from '@etg/wings';
import { css, cx, keyframes } from '@eti/styles';

const wrapperStyles = css`
  background-color: #fff;
  border-top-left-radius: ${vars.card.borderRadius};
  border-top-right-radius: ${vars.card.borderRadius};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const titleStyles = css`
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  padding: 16px;

  div:first-child {
    margin-right: 3px;
  }

  [dir='rtl'] & {
    div:first-child {
      margin-left: 3px;
      margin-right: 0;
    }
  }
`;

const fill = keyframes`
  0% { width: 0; }
  100% { width: 100%; }
`;

const loadingBarStyles = css`
  bottom: 0;
  height: 2px;
  position: absolute;
  width: 100%;
`;

const barStyles = css`
  animation: ${fill} 1.5s infinite;
  background-color: ${vars.colors.decoration.dark};
  height: 100%;
`;

interface ProgressBarProps {
  className?: string;
  hasCounter: boolean;
  text: string;
}

const ProgressBar = ({ className, hasCounter = false, text }: ProgressBarProps) => {
  const [counter, setCounter] = useState(1);

  useEffect(() => {
    if (hasCounter) {
      const delay = Math.floor(Math.random() * (800 - 400) + 400);
      const counterTimeOut = setTimeout(() => {
        setCounter(counter + 1);
      }, delay);
      return () => clearTimeout(counterTimeOut);
    }
    return () => {};
  }, [counter, hasCounter]);

  return (
    <div className={cx(wrapperStyles, className)}>
      <div className={titleStyles}>
        <div>{text}</div>
        {hasCounter && <div>{counter}</div>}
      </div>
      <div className={loadingBarStyles}>
        <div className={barStyles} />
      </div>
    </div>
  );
};

export default ProgressBar;
